import * as R from 'ramda'

import {TransactionState, TransactionType} from './constants'

import PropTypes from 'prop-types'

export const transactionState = PropTypes.oneOf(R.values(TransactionState))

export const transactionType = PropTypes.oneOf(R.values(TransactionType))
